import { createRequestActionsFor } from "./apiFetch";

export const PAINTING_OFFER = createRequestActionsFor("PAINTING_OFFER");
export const PAINTING_OFFER_CACHED = "PAINTING_OFFER_CACHED";
export const PAINTING_OFFER_CLEAR = "PAINTING_OFFER_CLEAR";
